import React from 'react';
import BaseLayout from './base.js';
import LoadMoreButton from './loadmore.js';
import Testimonial from '../testimonial.js';
import * as u from '../utils.js'

/*---------------------------------------------*/

export default class MasonryLayout extends BaseLayout {
	constructor(props) {
		super(props);

		this.prevContext = {};
		this.more = this.more.bind(this);
		this.loadedCount = 0;
	}

	updateLayout() {
		if (!this.masonry)
			return;

		// without timeout() appended items are not laid out correctly
		setTimeout(() => { 
			this.masonry.reloadItems(); 
			this.masonry.layout();

			// hide the animation of the appended items
			let items = Array.from(this.masonry.items);
			items.forEach((item) => item.element.style.opacity = 1);
		},100);
	}
	
	componentDidMount() {
		let grid = this.container.current;
		setTimeout(() => {
			this.masonry = new window.Masonry(grid,{
				itemSelector: '.testimonial-container',
				transitionDuration: 0
			});
			
			this.updateLayout(true);
		});

		window.inffuse.on('view-mode-changed', () => {
			this.loadedCount = 0;
			this.forceUpdate();
		});

		grid.addEventListener("content-changed", this.updateLayout);
	}

	more() {
		let itemsToLoad = this.context.get('layout.masonry.itemsToLoad',1);
		this.loadedCount = this.loadedCount + itemsToLoad;
		this.forceUpdate();
		
		u.dispatchEvent(this.container.current,'content-changed');
		
		window.ga && window.ga('send','event','navigation','masonry','load-more');
	}

	render() {
		let columns = 1*this.context.get('layout.cols');
		let spacing = this.context.get('layout.spacing');
		let paddingLeftRight = this.context.get('layout.padding.leftright',40,24);
		let paddingTopBottom = this.context.get('layout.padding.topbottom',40,24);

		let styles = {
			container: {
				overflow: 'hidden',
				paddingLeft: paddingLeftRight,
				paddingRight: paddingLeftRight,
				paddingTop: paddingTopBottom,
				paddingBottom: paddingTopBottom
			},
			navigation: {
				transform: `translateY(${paddingTopBottom/2}px)`
			},
			sizer: {
				margin: -1*spacing/2
			},
			testimonial: {
				width: `${100/columns}%`,
				opacity: 0,
				transition: 'opacity .1s'
			}
		}

		let items = this.props.items;
		
		// this.updateLayout();
		let navigation = null;
		let navType = this.context.get('layout.navigation.type','');
		if (navType === 'loadmore') {
			let itemsToShow = this.context.get('layout.masonry.itemsToShow',1);
			let itemsToLoad = this.context.get('layout.masonry.itemsToLoad',1);
			if (this.prevContext.itemsToShow !== itemsToShow || this.prevContext.itemsToLoad !== itemsToLoad) {
				this.loadedCount = 0;
				
				this.prevContext.itemsToShow = itemsToShow;
				this.prevContext.itemsToLoad = itemsToLoad;
			}
			
			let navAvailable = (itemsToShow + this.loadedCount) < items.length;
			if (!navAvailable) {
				styles.navigation.opacity = 0.2;
				styles.navigation.pointerEvents = "none";
			}

			navigation = <LoadMoreButton baseStyle={styles.navigation} onClick={this.more} />;

			items = items.slice(0, itemsToShow + this.loadedCount);
		}

		items = items.map((item,i) =>
			<Testimonial data={item} key={i} baseStyle={styles.testimonial} />
		);

		return (
			<div className="masonry" style={styles.container}>
				<div style={styles.sizer}>
					<div ref={this.container}>
						{items}
					</div>
				</div>
				{navigation}
			</div>
		)
	}
}

/*---------------------------------------------*/
